"use client";

import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useContext } from "react";
import MenuContext from "@/context/MenuProvider";
import { mainFasiliasNavMenus } from "@/layout/Navbar/Side/Sub/SubFasilitas";

const menus = mainFasiliasNavMenus;

const NavbarTopListItem = ({ anchor, menus }) => {
  const { stateListItem, setStateListItem, setStateAppBar } = useContext(MenuContext)!;

  return (
    <List
      sx={
        stateListItem[anchor]
          ? { display: "block" }
          : { display: "none" }
      }
    >
      {menus.map((menu, key) => (
        <ListItem key={key} disablePadding>
          {menu.path && <ListItemButton
            href={menu.path}
            sx={{
              borderBottom: "1px solid rgb(230,230,230)",
              borderLeft: "1px solid rgb(230,230,230)"
            }}
          >
            <ListItemText primary={menu.title}/>
          </ListItemButton>}
        </ListItem>
      ))}
    </List>
  );
};

export default NavbarTopListItem;
